function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("rect", {
  width: 60,
  height: 60,
  fill: "#fff"
}), React.createElement("path", {
  d: "M26,36V34.65a8.17,8.17,0,0,1,.82-3.88,10.79,10.79,0,0,1,2.85-3.19,16.39,16.39,0,0,0,3.14-3.09,4.78,4.78,0,0,0,.7-2.63,3.37,3.37,0,0,0-1.14-2.73,5.06,5.06,0,0,0-3.29-.95,10.94,10.94,0,0,0-3.59.57,24,24,0,0,0-3.22,1.38L20.55,16.4A17.5,17.5,0,0,1,29.43,14a9.42,9.42,0,0,1,6.35,2,7.05,7.05,0,0,1,2.34,5.61,8.28,8.28,0,0,1-.45,2.83,8.4,8.4,0,0,1-1.35,2.36,22.75,22.75,0,0,1-3.14,2.92,12.34,12.34,0,0,0-2.54,2.56A5,5,0,0,0,30,35.05v1Zm-.75,6.73q0-3.19,3.11-3.19a3.11,3.11,0,0,1,2.33.83,3.26,3.26,0,0,1,.8,2.36,3.39,3.39,0,0,1-.81,2.39,3,3,0,0,1-2.32.87,3,3,0,0,1-2.3-.85A3.38,3.38,0,0,1,25.25,42.73Z",
  fill: "#adafb5"
})));

function SvgUnknown(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 60 60"
  }, props), _ref);
}

export default __webpack_public_path__ + "static/media/unknown.8ffd520f.svg";
export { SvgUnknown as ReactComponent };